





import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as Namespace from "@/namespaces";
import { CatImage } from "@/store/types";

@Component({
  components: {},
})
export default class Home extends Vue {
  @Getter(Namespace.GET_SELECTED_CAT)
  public selectedCat!: CatImage;
}
